import { getMode } from '../reducers/config';
import type { ConfigMode } from '../types';
import type { State } from '../reducers';
import { Dispatch } from 'redux';

// Only execute thunk if configured mode matches specified one
export const executeIfInMode =
  <A, R>(mode: ConfigMode, args?: A) =>
  (thunk: (args: A | undefined) => (dispatch: Dispatch, getState: () => State) => R) =>
  (dispatch: Dispatch, getState: () => State) => {
    if (getMode(getState()) === mode) thunk(args)(dispatch, getState);
  };
